import React, { useEffect, useState } from 'react';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <div className={className} data-id="element-306">{children}</div>;
export const Button = ({
  href,
  children,
  variant = 'primary',
  className = ''
}: {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-4 md:px-8 py-4 rounded-full font-bold transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-xl text-center leading-tight break-words max-w-full';
  const variants = {
    primary: 'bg-gradient-to-r from-yellow-400 via-yellow-500 to-amber-500 text-navy-950 hover:shadow-[0_0_30px_rgba(250,204,21,0.5)] relative overflow-hidden group border border-yellow-300/50',
    secondary: 'bg-navy-800 text-white border border-navy-600 hover:bg-navy-700 hover:border-gold-500/50'
  };
  return <a href={href} className={`${baseStyle} ${variants[variant]} ${className} pt-[16px] pb-[16px]`} data-id="element-307">
      {variant === 'primary' && <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-308" />}
      <span className="relative z-10 font-[800]" data-id="element-309">{children}</span>
    </a>;
};
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 16,
    seconds: 48
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-310">
      <div className="relative bg-navy-900/90 px-3 md:px-5 py-3 md:py-4 rounded-xl border border-red-500/20 shadow-[0_8px_30px_rgba(0,0,0,0.3)] min-w-[64px] md:min-w-[80px]" data-id="element-311">
        {/* Subtle top highlight */}
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-red-400/30 to-transparent" data-id="element-312" />

        <div className="relative flex justify-center items-center h-8 md:h-12 overflow-hidden" data-id="element-313">
          <span className="text-3xl md:text-5xl font-mono font-bold text-red-400 tracking-tighter" data-id="element-314">
            {format(value)}
          </span>
        </div>
      </div>
      <span className="text-[10px] md:text-[11px] text-gray-400 uppercase font-medium tracking-widest mt-3" data-id="element-315">
        {label}
      </span>
    </div>;
  return <div className="flex items-start justify-center space-x-2 md:space-x-4" data-id="element-316">
      <TimeUnit value={timeLeft.hours} label="horas" data-id="element-317" />
      <div className="text-red-500/40 text-2xl md:text-4xl font-light pt-3 md:pt-5 animate-pulse" data-id="element-318">
        :
      </div>
      <TimeUnit value={timeLeft.minutes} label="minutos" data-id="element-319" />
      <div className="text-red-500/40 text-2xl md:text-4xl font-light pt-3 md:pt-5 animate-pulse" data-id="element-320">
        :
      </div>
      <TimeUnit value={timeLeft.seconds} label="segundos" data-id="element-321" />
    </div>;
};